import React from 'react';
import styled from 'styled-components';


//모달 창 배경
export default function Footer_Campaign_go_bg(props) {
    return (
        <ModalBg style={{backgroundColor:props.background}}></ModalBg>
    )
}


const ModalBg = styled.div`
    position: fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background:rgba(0,0,0,0.36);
    z-index: 400;
`